/**
 * next/image カスタムローダー（Akamai Image Manager 互換）
 *
 * Next.js 16 でビルトインの `akamai` loader が削除されたため、
 * 元の挙動を再現する custom loader として実装する。
 *
 * - 絶対URL（http/https）は CDN をそのまま使い `?imwidth=<width>` を付与
 * - public 配下のローカル画像はアプリ origin から配信し、クエリだけ付与
 *   （開発環境では Next.js の静的ファイル配信がクエリを無視して画像を返す）
 */
type LoaderParams = {
  src: string;
  width: number;
  quality?: number;
};

export default function akamaiLoader({ src, width }: LoaderParams): string {
  if (/^https?:\/\//.test(src)) {
    return `${src}?imwidth=${width}`;
  }
  const normalized = src.startsWith("/") ? src : `/${src}`;
  return `${normalized}?imwidth=${width}`;
}
